import Vuex from 'vuex';
import Vue from 'vue';
import room from './modules/room';
import seminarDate from './modules/seminar-date';
import review from './modules/review';
import cleverreach from './modules/cleverreach';
import booking from './modules/booking';
import language from './modules/language';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    room,
    seminarDate,
    review,
    cleverreach,
    booking,
    language
  }
});

